import React from 'react';
import { FormattedMessage } from 'react-intl';
import TradeCardEmpty from '../../TradeCardEmpty';
import { ClosingHeading } from '../../../pages/Closing/Styles';
import PendingDecisionCard from '../../TradeCard/PendingDecisionCard';
import { CardType } from '../../../_shared/types/trade';
import useTradeListItemsInClosingHighBid from '../../../_shared/hooks/trade/useTradeListItemsInClosingHighBid';

const ClosingHighBid = () => {
  const [tradeListItems] = useTradeListItemsInClosingHighBid();
  return (
    <>
      <ClosingHeading testId="page-header-subheading" variant="light">
        <FormattedMessage
          id="list.header.buy.closing.highbid.heading"
          values={{
            totalBid: '$0'
          }}
        />
      </ClosingHeading>
      {tradeListItems.map(tradeSummary => {
        return (
          <PendingDecisionCard
            id={`pendingTradeCard-${tradeSummary.id}`}
            key={`pendingTradeCard-${tradeSummary.id}`}
            testId={`pendingTradeCard-${tradeSummary.id}`}
            tradeSummary={tradeSummary}
          />
        );
      })}

      {tradeListItems.length === 0 && (
        <TradeCardEmpty
          variant={CardType.PLAIN}
          header={<FormattedMessage id="list.empty.closing.highbid.header" />}
          content={<FormattedMessage id="list.empty.closing.highbid.content" />}
        />
      )}
    </>
  );
};

export default ClosingHighBid;
